<div class="delete-label-dialog">
  <app-popup-top-line></app-popup-top-line>
  <div class="delete-label-dialog-header">
    <div class="title">
      {{ 'deleteLabelDialog.deleteLabelTitle' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>

  <div class="delete-label-dialog-body">
    <div class="textarea textarea-show">
      <textarea
        type="text"
        maxlength="20"
        placeholder="Business data"
        disabled
        value="{{ inputData.label.displayName }}"
        [ngStyle]="{
          'background-color': getLabelTransparentBackgroundColor(),
        }"
      ></textarea>
    </div>

    <div class="delete-label-dialog-body-content">
      {{ 'deleteLabelDialog.deleteLabelContent' | labelsProvider }}
    </div>

    <div class="section-divider"></div>
  </div>

  <div class="delete-label-dialog-footer">
    <button class="delete" cdkFocusInitial (click)="deleteButtonClick()">
      <span>{{ 'deleteLabelDialog.deleteLabelButtonText' | labelsProvider }}</span>
    </button>
  </div>
</div>
